<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-evgImport-wmPosSales',
  components: { PageTable },
}
</script>
